import { KYMW0900Model } from "../kymw0900.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { GetGroupingDataRequestModel } from '../vo/kymw0900-get-grouping-data-request.model';

/**
 * グルーピングデータ取得処理サービス
 *
 * @export GetGroupingDataService
 * @class GetGroupingDataService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetGroupingDataService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetGroupingDataService
   */
  private successFunc: Function;

  model: KYMW0900Model;
  vo: GetGroupingDataRequestModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGroupingDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        GroupingCode: this.vo.groupingCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetGroupingDataService
   */
  execute(model: any, vo: GetGroupingDataRequestModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getGroupingData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGroupingDataService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.setGroupingData(data);
      if (this.successFunc) {
        this.successFunc(data);
      }
    }
  }
}
